/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { HelpHelpCenterAri } from '@atlassian/ari/help/help-center';
import overviewAgentIdentityQuery, {
	type AgentOverviewQuery as overviewAgentIdentityQueryType,
} from './__generated__/AgentOverviewQuery.graphql.ts';

type CsmAgentOverviewEntryPointComponent = EntryPointComponent<
	{
		page: overviewAgentIdentityQueryType;
	},
	{},
	{},
	{} | null
>;

export const csmAgentOverviewEntryPoint: EntryPoint<
	CsmAgentOverviewEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<CsmAgentOverviewEntryPointComponent>(
		/* webpackChunkName: "async-csm-agent" */ './AgentOverview.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => {
		const { activationId } = tenantContext;
		const { helpCenterId } = context.match.params;

		if (!activationId || activationId === ':activationId') {
			return {};
		}
		if (!helpCenterId || helpCenterId === ':helpCenterId') {
			return {};
		}

		const helpCenterAri = HelpHelpCenterAri.create({
			activationId,
			helpCenterId,
		}).toString();

		return {
			queries: {
				page: {
					parameters: overviewAgentIdentityQuery,
					variables: {
						helpCenterAri,
						cloudId: tenantContext.cloudId,
					},
				},
			},
		};
	},
});
